const isWeekendDay = (date: Date) => {
  var day = date.getDay();
  if (day === 0 || day === 6) {
    return true;
  }
  return false;
};

export default isWeekendDay;
